import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=456c975c"
import script from "./Title.ts?vue&type=script&lang=ts&external"
export * from "./Title.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports